
import { cn } from "@/lib/utils";

interface HeadingProps {
  children: React.ReactNode;
  level?: 1 | 2 | 3 | 4;
  className?: string;
  color?: "primary" | "secondary" | "accent";
}

export const Heading = ({ 
  children, 
  level = 1, 
  className,
  color = "primary" 
}: HeadingProps) => {
  const colorClasses = {
    primary: "text-[#1A237E]",
    secondary: "text-[#2F80ED]",
    accent: "text-[#1B365D]"
  };

  const baseClasses = cn("font-bold", colorClasses[color], className);

  switch (level) {
    case 1:
      return <h1 className={cn("text-2xl sm:text-3xl", baseClasses)}>{children}</h1>;
    case 2:
      return <h2 className={cn("text-xl sm:text-2xl", baseClasses)}>{children}</h2>;
    case 3:
      return <h3 className={cn("text-lg sm:text-xl", baseClasses)}>{children}</h3>;
    case 4:
      return <h4 className={cn("text-base sm:text-lg", baseClasses)}>{children}</h4>;
    default:
      return <h1 className={cn("text-2xl sm:text-3xl", baseClasses)}>{children}</h1>;
  }
};

interface BodyTextProps {
  children: React.ReactNode;
  className?: string;
  color?: "primary" | "secondary" | "muted";
  size?: "sm" | "base" | "lg";
}

export const BodyText = ({ 
  children, 
  className,
  color = "primary",
  size = "base"
}: BodyTextProps) => {
  const colorClasses = {
    primary: "text-[#1B365D]",
    secondary: "text-[#2F80ED]",
    muted: "text-[#2F80ED]/60"
  };

  const sizeClasses = {
    sm: "text-sm",
    base: "text-base",
    lg: "text-lg"
  };

  return (
    <p className={cn(
      sizeClasses[size],
      colorClasses[color],
      "leading-relaxed",
      className
    )}>
      {children}
    </p>
  );
};
